import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { NgZorroAntdModule, NZ_I18N, it_IT } from "ng-zorro-antd";

import { registerLocaleData } from "@angular/common";
import localeIt from "@angular/common/locales/it";
registerLocaleData(localeIt);

// ## PITPES
// import { SqrtPipe } from './app.sqrt';

// ## PROVIDERS
import { AppComponent } from "./app.component";
import { GlobalComponent } from "../environments/global";

// ## COMPONENTS
import { LoginComponent } from "../login/login.component";
// ## COMPONENTS HOME
import { HomeComponent } from "../home/home.component";
import { TempiComponent } from "../home/tempi/tempi.component";
import { DipendentiComponent } from "../home/dipendenti/dipendenti.component";
import { DipendentiReportComponent } from "../home/dipendenti-report/dipendenti.report";
import { OrdiniComponent } from "../home/ordini/ordini.component";
import { OrdiniReportComponent } from "../home/ordini-report/ordini.report";
import { IncidenzeReportComponent } from "../home/incidenze-report/incidenze.report";
import { MeseReportComponent } from "../home/mese-report/mese-report";
import { PremiReportComponent } from "../home/premi-report/premi-report";
import { ExcelReportComponent } from "../home/excel-report/excel-report";
import { RfidComponent } from "../home/rfid/rfid.component";
import { RfidGgComponent } from "../home/rfid-gg/rfid-gg.component";
// ## COMPONENTS TRACK
import { TrackComponent } from "../track/track.component";
import { UtenteComponent } from "../track/utente/utente.component";
import { OrdineComponent } from "../track/ordine/ordine.component";
import { TempoComponent } from "../track/tempo/tempo.component";
import { CheckComponent } from "../track/check/check.component";
import { InsertComponent } from "../track/insert/insert.component";

export const appRoutes: Routes = [
  { path: "", redirectTo: "track", pathMatch: "full" },
  { path: "admin", component: LoginComponent },
  {
    path: "home",
    component: HomeComponent,
    children: [
      { path: "tempi", component: TempiComponent, outlet: "homeContent" },
      {
        path: "dipendenti",
        component: DipendentiComponent,
        outlet: "homeContent",
      },
      {
        path: "dipendenti.report",
        component: DipendentiReportComponent,
        outlet: "homeContent",
      },
      { 
        path: "ordini", 
        component: OrdiniComponent, 
        outlet: "homeContent" },
      {
        path: "ordini.report",
        component: OrdiniReportComponent,
        outlet: "homeContent",
      },
      {
        path: "incidenze.report",
        component: IncidenzeReportComponent,
        outlet: "homeContent",
      },
      {
        path: "mese.report",
        component: MeseReportComponent,
        outlet: "homeContent",
      },
      {
        path: "premi.report",
        component: PremiReportComponent,
        outlet: "homeContent",
      },
      {
        path: "excel.report",
        component: ExcelReportComponent,
        outlet: "homeContent",
      },
      { path: "rfid", component: RfidComponent, outlet: "homeContent" },
      { path: "rfid-gg", component: RfidGgComponent, outlet: "homeContent" },
    ],
  },
  {
    path: "track",
    component: TrackComponent,
    children: [
      { path: "utente", component: UtenteComponent, outlet: "trackContent" },
      { path: "ordine", component: OrdineComponent, outlet: "trackContent" },
      { path: "tempo", component: TempoComponent, outlet: "trackContent" },
      { path: "check", component: CheckComponent, outlet: "trackContent" },
      { path: "insert", component: InsertComponent, outlet: "trackContent" },
    ],
  },
  // { path: '**', redirectTo: '/track', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    // HOME
    HomeComponent,
    DipendentiComponent,
    OrdiniComponent,
    TempiComponent,
    DipendentiReportComponent,
    OrdiniReportComponent,
    IncidenzeReportComponent,
    MeseReportComponent,
    ExcelReportComponent,
    PremiReportComponent,
    RfidComponent,
    RfidGgComponent,
    // TRACK
    TrackComponent,
    UtenteComponent,
    OrdineComponent,
    TempoComponent,
    CheckComponent,
    InsertComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgZorroAntdModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
  ],
  providers: [
    GlobalComponent,
    { provide: NZ_I18N, useValue: it_IT },
    { provide: LOCALE_ID, useValue: "it" },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
